/*
|-------------------------------------------------------------------------------
| 一阶段loading
|-------------------------------------------------------------------------------
*/
import { defineStore } from '~/utils/store'
import type { IStoreState } from '~/utils/store'

/**
 * store
 */
const StageOneLoadingStore = defineStore({
  state: () => ({
    time: 15,
    page: '',
  }),
  mutations: {
    updateTime(state, data) {
      state.time = data
    },
  },
})

export default StageOneLoadingStore
export type IStageOneLoadingStoreState = IStoreState<
  typeof StageOneLoadingStore.state
>
